import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CustomFieldsMapped } from '../models/custom-field';

@Component({
  selector: 'tn-field-free-text',
  templateUrl: './field-free-text.component.html',
  styleUrls: ['./field-free-text.component.scss'],
  host: { 'component-root': 'shared' }
})
export class FieldFreeTextComponent implements OnInit {

  @Input() field: CustomFieldsMapped;
  @Input() isInput: boolean = false;

  @Output() onFieldUpdate: EventEmitter<CustomFieldsMapped> = new EventEmitter<CustomFieldsMapped>(null);
  freeText: string;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.freeText = this.field.answer.value;
  }

  getAnswerValue(): string {
    return this.freeText;
  }

  onChange() {
    this.field.answer.value = this.getAnswerValue();
    this.onFieldUpdate.emit(this.field);
  }

}
